import React, { useEffect, useState } from "react";
import { Layout, FormParser,PopupModal } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const SpecialitiesEdit = () => {
    const[Error,SetError]=useState("")
    const[popupType,setpopupType]=useState("")
    const MastersModal=Masters.Specialities
    const formSubmit = (Data) => {
        axiosConfig.defaults.headers['Content-Type'] = 'multipart/form-data';
            axiosConfig.put(`/masters/specialities/${id}/`, Data).then(res => {
                console.log(res)
                setpopupType("success")
            }).catch(error => {
                console.log(error)
                let ErrorData=[]
                ErrorData.push({
                    code:error.response.data.code||["null"],
                    name:error.response.data.name||["null"],
                    })
                    console.log(ErrorData[0])
            if(ErrorData[0].code[0]==="This field must be unique."){
                SetError("Code Already Exists")
            }
            if(ErrorData[0].name[0]==="This field must be unique."){
                SetError("Name Already Exists")
            }
                setpopupType("error")
            })
    }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/specialities/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
            
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <Layout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit Specialities {id}</h5>
                    <NavLink to="/dashboard/masters/specialities" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/masters/specialities"/>
                }
            </Layout>
        </>
    )

}
export {SpecialitiesEdit}